import { render, staticRenderFns } from "./MiniStatistic.vue?vue&type=template&id=f01a0f96&scoped=true"
import script from "./MiniStatistic.vue?vue&type=script&lang=js"
export * from "./MiniStatistic.vue?vue&type=script&lang=js"
import style0 from "./MiniStatistic.vue?vue&type=style&index=0&id=f01a0f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01a0f96",
  null
  
)

export default component.exports